import React from 'react';

import { anelDeFoco, styledDs as styled } from '../../../styles/theme';

export type DsSelectOption = {
  value: string;
  label: string;
};

export type DsSelectProps = {
  label: string;
  options: DsSelectOption[];
} & React.SelectHTMLAttributes<HTMLSelectElement>;

const Field = styled.label`
  display: inline-flex;
  flex-direction: column;
  gap: 4px;
  font-family: ${({ theme }) => theme.font.family};

  span {
    font-size: ${({ theme }) => theme.font.sizeXs};
    font-weight: ${({ theme }) => theme.weight.semibold};
    text-transform: uppercase;
    letter-spacing: ${({ theme }) => theme.tracking.eyebrow};
    color: ${({ theme }) => theme.colors.textMuted};
  }

  select {
    height: 32px;
    min-width: 160px;
    border-radius: ${({ theme }) => theme.radius.md};
    border: 1px solid ${({ theme }) => theme.colors.border};
    background: ${({ theme }) => theme.colors.surface};
    color: ${({ theme }) => theme.colors.textPrimary};
    padding: 0 8px;
    font-family: ${({ theme }) => theme.font.family};
    font-size: ${({ theme }) => theme.font.sizeSm};
    cursor: pointer;
  }

  select:focus-visible {
    ${anelDeFoco('-1px')}
  }
`;

export const DsSelect: React.FC<DsSelectProps> = ({ label, options, ...rest }) => (
  <Field>
    <span>{label}</span>
    <select aria-label={label} {...rest}>
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  </Field>
);
